import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Button } from "@/components/ui";
import { useDeleteMutation, usePermission, useToast } from "@/hooks";
import { DisplayError } from "@/utils";
import { ModelDialog } from "./model-dialog";

export function DeleteModelDialog({ id, name, type = false, onDeleted }: { id: string; name: string; type?: boolean; onDeleted?: () => void }) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const client = useQueryClient();
  const { checkPermission } = usePermission();
  const { toast } = useToast();
  const endpoint = `/${type ? "models-types" : "models"}/${id}`;
  const mutation = useDeleteMutation(endpoint, type ? "models-types" : "models");
  const allowed = type ? checkPermission("modelstypes", "delete modelstypes") : checkPermission("models", "delete models");
  if (!allowed) return null;
  return <ModelDialog open={open} onOpenChange={value => { if (!mutation.isLoading) { setOpen(value); setError(""); } }} title={type ? "Excluir tipo de modelo?" : "Excluir modelo?"}
    description={`Você está excluindo “${name}”. Esta ação não pode ser desfeita.`}
    trigger={<Button type="button" variant="ghost" aria-label={`Excluir ${name}`}>Excluir</Button>}>
    {type && <p className="text-sm text-app-fg">Tipos vinculados a modelos podem impedir a exclusão. Revise os vínculos antes de continuar.</p>}
    {error && <p role="alert" className="text-sm text-app-danger">{error}</p>}
    <div className="flex justify-end gap-2">
      <Button type="button" variant="outline" disabled={mutation.isLoading} onClick={() => setOpen(false)}>Cancelar</Button>
      <Button type="button" variant="destructive" disabled={mutation.isLoading} isLoading={mutation.isLoading} onClick={async () => {
        if (!allowed || mutation.isLoading) return;
        setError("");
        try {
          await mutation.mutateAsync({ endpoint });
          await client.invalidateQueries({ queryKey: ["models"] });
          toast({ title: "Sucesso", description: "Registro excluído." });
          setOpen(false);
          onDeleted?.();
        } catch (cause) { setError(DisplayError(cause, "Não foi possível excluir o registro.")); }
      }}>Confirmar exclusão</Button>
    </div>
  </ModelDialog>;
}
